import * as viewModels from '../../view/view-models';
import * as models from '../../domain/models';
import * as actions from '../actions/charter-pricing-detail';

import * as _ from 'lodash';

export interface State {
  isLoaded: boolean;
  isLoading: boolean;
  item: models.CharterPricingRule;
  pristine: boolean;
  isValid: boolean;
  validationLoading: boolean;
}

const initialState: State = {
  isLoaded: false,
  isLoading: false,
  pristine: true,
  item: null,
  isValid: false,
  validationLoading: false,
};

export function reducer(state = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.ADD:
    case actions.SAVE:
    case actions.LOAD: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    }

    case actions.ADD_SUCCESS:
    case actions.SAVE_SUCCESS:
    case actions.LOAD_SUCCESS: {
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        pristine: true,
        item: _.cloneDeep(action.payload.item),
      };
    }

    case actions.ADD_FAIL:
    case actions.SAVE_FAIL: {
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        pristine: false,
      };
    }

    case actions.LOAD_FAIL: {
      return {
        ...initialState,
        isLoaded: true,
      };
    }

    case actions.SET: {
      return {
        ...state,
        pristine: false,
        item: _.cloneDeep(action.payload.item),
      };
    }

    case actions.BYPASS_LOAD: {
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };
    }

    case actions.VALIDATE: {
      return {
        ...state,
        isValid: false,
        validationLoading: true,
      };
    }

    case actions.VALIDATE_RESPONSE: {
      return {
        ...state,
        isValid: _.cloneDeep(action.payload.valid),
        validationLoading: false,
      };
    }

    default: {
      return state;
    }
  }
}

export const getIsLoaded = (state: State) => state.isLoaded;
export const getIsLoading = (state: State) => state.isLoading;
export const getItem = (state: State) => state.item;
export const getPristine = (state: State) => state.pristine;
export const getIsValid = (state: State) => state.isValid;
export const getValidationLoading = (state: State) => state.validationLoading;
